(function () {
  var STORAGE_KEY = 'moxom_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: list.length } }));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) > -1;
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(handle);
    }
    saveWishlist(list);
    return list.indexOf(handle) > -1;
  }

  function updateButtonState(btn) {
    var handle = btn.getAttribute('data-product-handle');
    var active = isInWishlist(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(updateButtonState);
  }

  function init() {
    refreshAllButtons();
    updateCountBadges();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');
      toggle(handle);
      document
        .querySelectorAll('[data-wishlist-toggle][data-product-handle="' + handle + '"]')
        .forEach(updateButtonState);
    });

    document.addEventListener('wishlist:change', updateCountBadges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MoxomWishlist = { getWishlist: getWishlist, toggle: toggle, isInWishlist: isInWishlist };
})();
